import axios from 'axios'
import { resReject, resResolve, reqReject, reqResolve } from './interceptors'

const createRequest = (options = {}) => {
  const defaults = {
    timeout: 10000,
    validateStatus: function (status) {
      return status >= 200 && status < 500
    },
  }
  const instance = axios.create({
    ...defaults,
    ...options,
  })
  instance.interceptors.request.use(reqResolve, reqReject)
  instance.interceptors.response.use(resResolve, resReject)
  return instance
}

export const request = createRequest({
  baseURL: import.meta.env.VITE_BASE_API,
})
